import React, { useState } from 'react';
import FlipCard from './flip-cart';

const cardsData = [
    {
        image: '/Home/Hero/Gondal.jpeg',
        title: 'Jetpur Gondal Rajkot',
        subtitle: "NHAI",
        details: [
            { label: 'Project name', value: 'Jetpur Gondal Rajkot' },
            { label: 'Service', value: 'AE' },
            { label: 'Client', value: 'NHAI' },
            { label: 'Lenght', value: '67.4 km' },
            { label: 'Cost', value: '1205 Cr' },
        ],
    },
    {
        image: '/Home/Hero/Dak3.jpeg',
        title: 'Dak-PKG-3',
        subtitle: "NHAI",
        details: [
            { label: 'Project name', value: 'Dak-PKG-3' },
            { label: 'Service', value: 'AE' },
            { label: 'Client', value: 'NHAI' },
            { label: 'Lenght', value: '39.50 km' },
            { label: 'Cost', value: '1094 Cr' },
        ],
    },
     {
        image: '/Home/Hero/Samakhiyali.jpeg',
        title: 'Samakhiyali Santalpur',
        subtitle: "NHAI",
        details: [
            { label: 'Project name', value: 'Samakhiyali Santalpur' },
            { label: 'Service', value: 'IE' },
            { label: 'Client', value: 'NHAI' },
            { label: 'Lenght', value: '90.9 km' },
            { label: 'Cost', value: '1370 Cr' },
        ],
    },
    {
        image: '/Home/Hero/Kanpur.jpeg',
        title: 'Kanpur Ring Road',
        subtitle: "NHAI",
        details: [
            { label: 'Project name', value: 'Kanpur Ring Road' },
            { label: 'Service', value: 'AE' },
            { label: 'Client', value: 'NHAI' },
            { label: 'Lenght', value: '47.884 km' },
            { label: 'Cost', value: '647Cr' },
        ],
    },
   
     {
        image: '/Home/Hero/Hardio.jpeg',
        title: 'Hardoi Bypass',
        subtitle: "NHAI",
        details: [
            { label: 'Project name', value: 'Hardoi Bypass' },
            { label: 'Service', value: 'IE' },
            { label: 'Client', value: 'NHAI' },
            { label: 'Lenght', value: '54.429 km' },
            { label: 'Cost', value: '864 Cr' },
        ],
    },
     {
        image: '/Home/Hero/PadharBijni.jpeg',
        title: 'padhar Bijni',
        subtitle: "NHAI",
        details: [
            { label: 'Project name', value: 'padhar Bijni' },
            { label: 'Service', value: 'IE' },
            { label: 'Client', value: 'NHAI' },
            { label: 'Lenght', value: '19.050 km' },
            { label: 'Cost', value: '545 Cr' },
        ],
    },
];

export default function FlipCardShowcase() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const cardsPerPage = 3;

    const handleNext = () => {
        setCurrentIndex((prev) =>
            prev + cardsPerPage < cardsData.length ? prev + cardsPerPage : 0
        );
    };

    const handlePrev = () => {
        setCurrentIndex((prev) =>
            prev - cardsPerPage >= 0 ? prev - cardsPerPage : Math.max(0, cardsData.length - cardsPerPage)
        );
    };

    const visibleCards = cardsData.slice(currentIndex, currentIndex + cardsPerPage);

    return (
        <div className="from-slate-50 to-slate-100  px-4 sm:px-6 lg:px-8 ">
            <div className="max-w-7xl mx-auto">

                {/* Cards Grid with Navigation */}
                <div className="flex items-center justify-center gap-8">
                    {/* Left Arrow */}
                    <button
                        onClick={handlePrev}
                        className="flex items-center justify-center w-12 h-12 bg-slate-800 hover:bg-slate-900 text-white rounded-full transition-colors duration-300 shadow-lg"
                        aria-label="Previous cards"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>

                    {/* Cards Container */}

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10 flex-1">
                        {visibleCards.map((card, index) => (
                            <FlipCard
                                key={currentIndex + index}
                                image={card.image}
                                title={`${card.title} , ${card.subtitle ?? ""}`}
                                details={card.details}
                            />
                        ))}
                    </div>

                    {/* Right Arrow */}
                    <button
                        onClick={handleNext}
                        className="flex items-center justify-center w-12 h-12 bg-slate-800 hover:bg-slate-900 text-white rounded-full transition-colors duration-300 shadow-lg"
                        aria-label="Next cards"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
}
